import { ApiType } from "@gymflow/common";
import { InvoiceReceiptDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { staffQueryKeys } from "./staffQueryKeys";

export function useStaffGetInvoiceReceipt(
  {
    api,
    invoiceNumber,
  }: {
    api: ApiType;
    invoiceNumber: string | undefined;
  },
  opts?: Omit<
    UseQueryOptions<InvoiceReceiptDTO, unknown>,
    "queryKey" | "queryFn"
  >,
) {
  return useQuery({
    queryKey: staffQueryKeys.invoice(invoiceNumber),
    queryFn: async () => {

      const { data } = await api.staffApi.getInvoiceReceipt(
        invoiceNumber!
      );
      return data;
    },
    ...opts,
    enabled: !!invoiceNumber && opts?.enabled,
  });
}
